import type { AbsenceData2, ScheduleDay2 } from "../types";
import { getCellClassAndIcon } from "../utils/absenceClassHelpers";

interface CalendarCell2Props {
  date: Date;
  text: string;
  view: string;
  theme: string | undefined;
  employeeId: number;
  holidayData: Record<number, AbsenceData2[]>;
  schedule: Record<string, ScheduleDay2>;
  startDate: Date;
  endDate: Date;
  onDoubleClick: (date: Date) => void;
  lastCellClickTime: React.MutableRefObject<number>;
}

export function CalendarCell2({
  date,
  text,
  view,
  theme,
  employeeId,
  holidayData,
  schedule,
  startDate,
  endDate,
  onDoubleClick,
  lastCellClickTime,
}: CalendarCell2Props) {
  if (view !== "month") {
    return (
      <div style={{ minHeight: "100px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", borderRadius: "4px", fontSize: "15px", fontWeight: "bold" }}>
        <div>{text}</div>
      </div>
    );
  }

  const formattedDate = new Date(date).toLocaleDateString("en-CA");
  const scheduleData = schedule[formattedDate];
  const dayType = scheduleData?.dayType ?? null;

  const { changeClass, icon, absenceDataForCell } = getCellClassAndIcon(
    formattedDate, theme, employeeId, holidayData, dayType,
  );

  if (date < startDate || date > endDate) {
    return (
      <div
        className={`empty-cell-render ${changeClass}`}
        style={{ minHeight: "100px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", borderRadius: "4px", fontWeight: "bold" }}
      >
        {text}
      </div>
    );
  }

  return (
    <div
      id="cell-render"
      className={changeClass}
      style={{ minHeight: "100px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", borderRadius: "4px", touchAction: "manipulation", userSelect: "none" }}
      onClick={() => {
        const now = Date.now();
        if (now - lastCellClickTime.current < 300) {
          lastCellClickTime.current = 0;
          onDoubleClick(date);
        } else {
          lastCellClickTime.current = now;
        }
      }}
    >
      <div style={{ marginBottom: "4px", fontSize: "15px", fontWeight: "bold" }}>{text}</div>
      <div>
        {absenceDataForCell ? "-" : scheduleData?.hours}
        {icon && <div style={{ marginTop: 4 }}>{icon}</div>}
      </div>
    </div>
  );
}
